'use es6';

import Client from 'AdsUI/data/Client';
export const fetchAll = () => Client.apiRequest('pipelines/v2/lifecycle-pipelines/CONTACT');